<template>
  <div class="question-form" >
    <!-- <div class="header">
      <div class="packet-title">
        <div class="packet-title-base">
          {{ getEnumsDisplay('RegistrationInputMainType', type) }}
          <i class="el-icon-loading icon-font" v-if="loading"></i>
        </div>

        <div>
          
        </div>
      </div>
      <span>Spread the joy by allowing participants to bring their loved ones to your event.</span>
    </div> -->

    <div class="hl-questions-header" v-if="type != 7">
      <el-button-group>
        <el-button type="primary" size="small" :icon="loading ? 'el-icon-loading' : 'fas fa-plus'"  round @click="addNewQuestion"> {{$t('components.registerForm.questionLibrary.addQuestion')}}</el-button>
      </el-button-group>
    </div>

    <div class="tab-contents" v-if="currentQuestions.length > 0 && !loading">
      <div class="question-head" v-if="type != 7">
        <div>{{$t('components.registerForm.questionLibrary.label')}}</div>
        <div>{{$t('components.registerForm.questionLibrary.questionType')}}</div>
        <div class="text-center">{{$t('components.registerForm.questionLibrary.required')}}</div>
        <div class="text-center">{{$t('components.registerForm.questionLibrary.show')}}</div>
        <div></div>
      </div>
      <template v-if="currentQuestions">

        <draggable :list="currentQuestions" tag="div" class="list-group-o" draggable=".draggable-item" group="main" v-bind="dragOptions" handle=".movable" :move="checkMove">
          <template v-for="(question, index) in currentQuestions">
            <RecursiveQuestion v-if="question.parentQuestionId == null && question.parentAnswerId == null" :key="question + index" :question="question" :baseId="id" :mainType="type" :saveStatus="bulkSaveCompleted" :active="activeIndex == index" class="static" />
          </template>
        </draggable>

        <!-- <RecursiveQuestion v-for="(question, index) in currentQuestions.filter((x) => x.parentQuestionId == null && x.parentAnswerId == null && (x.type == 1000 || x.type == 10001 || x.type == 1 || x.type == 2))" :key="question + index" :question="question" :baseId="id" :mainType="type" class="static" />
        <draggable :list="currentQuestions" tag="div" class="list-group-o" draggable=".draggable-item" group="main" v-bind="dragOptions">
          <RecursiveQuestion v-for="(question, index) in currentQuestions.filter((x) => x.parentQuestionId == null && x.parentAnswerId == null && x.type != 1 && x.type != 2 && x.type != 1000 && x.type != 10001)" :key="question + index" :question="question" :baseId="id" :mainType="type" class="static" />
        </draggable> -->
      </template>
    </div>

    <div class="tab-contents mt-3" v-else-if="currentQuestions.length == 0 && !loading">
      <div class="flush-box-question">
        <div class="box" @click="getQuestionObject(10)">
          <div class="box-title">
            {{$t('components.registerForm.questionLibrary.singleLineText')}}
            <span>{{$t('components.registerForm.questionLibrary.singleLineTextMsg')}}</span>
          </div>
          <div class="box-icon">
            <i class="fas fa-text-width"></i>
          </div>
        </div>
        <div class="box" @click="getQuestionObject(500)" v-if="type != 2">
          <div class="box-title">
            {{$t('components.registerForm.questionLibrary.informationBanner')}}
            <span>{{$t('components.registerForm.questionLibrary.informationBannerMsg')}}</span>
          </div>
          <div class="box-icon">
            <i class="fas fa-info-circle"></i>
          </div>
        </div>
        <div class="box" @click="getQuestionObject(11)" v-else>
          <div class="box-title">
           {{$t('components.registerForm.questionLibrary.multiLineText')}}
            <span>{{$t('components.registerForm.questionLibrary.multiLineTextMsg')}}</span>
          </div>
          <div class="box-icon">
            <i class="fas fa-text-height"></i>
          </div>
        </div>
        <div class="box" @click="getQuestionObject(100)">
          <div class="box-title">
            {{$t('components.registerForm.questionLibrary.multipleChoiceQuestion')}}
            <span>{{$t('components.registerForm.questionLibrary.multipleChoiceQuestionMsg')}}</span>
          </div>
          <div class="box-icon">
            <i class="far fa-check-circle"></i>
          </div>
        </div>
        <div class="box" @click="getQuestionObject(15)">
          <div class="box-title">
            {{$t('components.registerForm.questionLibrary.singleChoiceQuestion')}}
            <span>{{$t('components.registerForm.questionLibrary.singleChoiceQuestionMsg')}}</span>
          </div>
          <div class="box-icon">
            <i class="far fa-dot-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('components.registerForm.questionLibrary.addQuestion')" :visible.sync="newQuestionDialog" class="large" center append-to-body destroy-on-close>
      <div id="addquestion-dialog" class="custom-modal">
        <div class="modal-body no-footer">
              
          <div class="add-question-container">
            <div class="question-list" v-if="type != 2">
              <div class="title">{{$t('components.registerForm.questionLibrary.predefinedQuestions')}}</div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.photo')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 32) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 32)" type="primary"  @click="getQuestionObject(32)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.title')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 4) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 4)" type="primary" @click="getQuestionObject(4)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.instituon')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 33) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 33)" type="primary" @click="getQuestionObject(33)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.company')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 3) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 3)" type="primary" @click="getQuestionObject(3)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.department')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 34) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 34)" type="primary" @click="getQuestionObject(34)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.school')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 5) ? 'fas fa-check' : 'fas fa-plus'" :disabled="currentQuestions.some(x => x.type == 5)" type="primary" @click="getQuestionObject(5)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.mobilePhone')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 26) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 26)" @click="getQuestionObject(26)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.workPhone')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 27) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 27)" @click="getQuestionObject(27)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.country')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 8) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 8)" @click="getQuestionObject(8)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.state')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 28) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 28)" @click="getQuestionObject(28)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.city')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 9) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 9)" @click="getQuestionObject(9)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.postalCode')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 29) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 29)" @click="getQuestionObject(29)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.addressLine')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 30) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 30)" @click="getQuestionObject(30)"></el-button>
              </div>
              <!-- <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.hesCode')}}</div>
                <el-button circle size="small" :icon="currentQuestions.some(x => x.type == 31) ? 'fas fa-check' : 'fas fa-plus'" type="primary" :disabled="currentQuestions.some(x => x.type == 31)" @click="getQuestionObject(31)"></el-button>
              </div> -->
            </div>
            <div class="question-list">
              <div class="title">{{$t('components.registerForm.questionLibrary.customQuestions')}}</div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.singleLineText')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary"  @click="getQuestionObject(10)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.multiLineText')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(11)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.email')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(12)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.phoneNumber')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(13)"></el-button>
              </div>
              <div class="list" v-if="type != 2">
                <div class="title">{{$t('components.registerForm.questionLibrary.fileUpload')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(104)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.number')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(14)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.multipleChoiceQuestion')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(100)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.singleChoiceQuestion')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(15)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.selectDropdown')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(16)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.datepicker')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(101)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.timepicker')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(102)"></el-button>
              </div>
              <!-- <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.richTextEditor')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(103)"></el-button>
              </div> -->
          
            </div>
            <div class="question-list">

              <div class="title">{{$t('components.registerForm.questionLibrary.informationQuestions')}}</div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.slider')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(202)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.rate')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(200)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{$t('components.registerForm.questionLibrary.emotionRate')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(201)"></el-button>
              </div>
              <div class="list" v-if="type != 7 && type != 4 && type != 2">
                <div class="title">{{$t('components.registerForm.questionLibrary.infoBlock')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(500)"></el-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import RecursiveQuestion from './RecursiveQuestion.vue';
import draggable from 'vuedraggable';

export default {
  props: ['type', 'id'],
  data() {
    return {
      loading: true,
      newQuestionDialog: false,
      saveQuestionsTimeout: null,
      activeIndex: null,
      bulkSaveCompleted: false,
    };
  },
  components: {
    RecursiveQuestion,
    draggable,
  },
  computed: {
    currentQuestions() {
      return this.$store.getters.getCurrentQuestions;
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
        filter: 'static',
      };
    },
  },
  async mounted() {
    await this.getQuestions();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    checkMove(e) {
      this.activeIndex = e.draggedContext.futureIndex;
    },
    async getQuestions() {
      // if (this.type != 5 && this.type != 4 && this.type != 2 && this.type != 7 && this.type != 3) {
      //   await this.$store.dispatch('getquestionLibraryOneQuestion', this.id);
      // }
      await this.$store.dispatch('getQuestionsObject', { type: this.type, id: this.id });
      if(this.type == 7 && this.currentQuestions.length == 0){
        await this.getQuestionObject(15);
      }
    },
    addNewQuestion() {
      this.newQuestionDialog = true;
    },
    async getQuestionObject(type) {
      var res = await this.$store.dispatch('getQuestionObject', {
        type: type,
        mainType: this.type,
        registrationFormId: this.id,
        parentAnswerId: null,
        parentQuestionId: null,
      });
      this.currentQuestions.push(res);
    },
  },
  watch: {
    currentQuestions: {
      deep: true,
      async handler() {
        if (this.saveQuestionsTimeout != null) clearTimeout(this.saveQuestionsTimeout);
        this.bulkSaveCompleted = true;
        this.saveQuestionsTimeout = setTimeout(async () => {
          var payload = {
            registrationFormId: this.id,
            type: this.type,
            items: this.currentQuestions,
          };
          await this.$store.dispatch('saveQuestionsForm', payload);
          this.activeIndex = null;
          this.bulkSaveCompleted= false;
        }, 500);
      },
    },
  },
  async type() {
    await this.getQuestions();
  },
  async id() {
    await this.getQuestions();
  },
};
</script>

<style lang="less">

.hl-questions-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.question-form {
  & > .header {
    & > .title {
      display: flex;
      flex-direction: column;
      font-weight: bold;
    }
    & > .packet-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      .packet-title-base {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
    }
    & > span {
      font-weight: 400;
    }
  }
}

.question-head {
  display: grid;
  grid-template-columns:1fr 180px 90px 90px 90px;
  padding: 10px;
  margin-top: 1rem;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;
}
.add-question-container {
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .question-list {
    padding: 1rem 1rem;
    border-right: 1px solid #ccc;
    &:last-child {
      border-right: none;
    }
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .title {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
.flush-box-question {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  .box {
    cursor: pointer;
    background: #f1f1f1;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px;
    gap: 1rem;
    justify-content: space-between;
    min-height: 100px;

    .box-title {
      display: flex;
      flex-direction: column;
      font-weight: bold;
      font-size: 15px;
      color: #292f3b;
      span {
        font-weight: 400;
        line-height: 16px;
        font-size: 13px;
        color: #505763;
      }
    }
    .box-icon {
      width: 45px;
      height: 45px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #03658c;
      border-radius: 12px;
      i {
        font-size: 16px;
        color: white;
      }
    }
  }
}
.icon-font {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/QuestionLibrary.vue